import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AuthService } from "app/services/auth/auth.service";
import { environment } from "environments/environment";

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
	authSvc = inject(AuthService);

	intercept(req: HttpRequest<unknown>, next: HttpHandler) {
		if (!req.headers.has("Content-Type") && !req.headers.has("x-multipart")) {
			req = req.clone({ setHeaders: { "Content-Type": "application/json; charset=utf-8" } });
		}

		req = this.addAuthenticationToken(req);
		return next.handle(req);
	}

	private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
		const token = this.authSvc.getAccessToken();
		if (!token) return request;
		if (
			!request.url.includes(environment.API_URL) ||
			request.url.includes("auth/token") ||
			request.url.includes("auth/registro") ||
			request.url.includes("auth/confirm-user") ||
			request.url.includes("auth/validateHash") ||
			request.url.includes("auth/recuperarPassword")
		) {
			return request;
		}
		return request.clone({ setHeaders: { Authentication: `Bearer ${token}` } });
	}
}
